import React, {ReactNode, memo} from 'react';
import cx from 'classnames';
import {Text} from '@priority-software/priority-style-react';
import {CheckedValue} from './enum';
import styles from './styles.module.scss';
import {createDataTestId} from '../../utils/dataTestId';

export type Props = {
    checked: CheckedValue;
    onChange: (checked: CheckedValue) => void;
    componentClasses?: string;
    left: ReactNode;
    right: ReactNode;
    size?: 'small' | 'medium' | 'large';
    largeWidth?: boolean;
};

export const ToggleButton = memo(
    ({
        onChange,
        checked,
        componentClasses,
        right,
        left,
        size = 'medium',
        largeWidth = false
    }: Props) => {
        const checkedLeft = checked === CheckedValue.left;
        const checkedRight = checked === CheckedValue.right;

        const handleToggleSide = () => {
            const nextValue =
                checked === CheckedValue.left ? CheckedValue.right : CheckedValue.left;
            onChange(nextValue);
        };

        return (
            <div
                {...createDataTestId('toggle-button-container', false)}
                onClick={handleToggleSide}
                className={cx(styles.toggleOperator, componentClasses, {
                    [styles.small]: size === 'small',
                    [styles.medium]: size === 'medium',
                    [styles.large]: size === 'large',
                    [styles.left]: checkedLeft,
                    [styles.right]: checkedRight
                })}
            >
                <Text
                    {...createDataTestId('toggle-button-left', true)}
                    skin="paragraph-2"
                    componentClasses={cx(styles.item, {
                        [styles.activeOperator]: checked === CheckedValue.left,
                        [styles.largeWidth]: largeWidth
                    })}
                >
                    {left}
                </Text>
                <Text
                    {...createDataTestId('toggle-button-right', true)}
                    skin="paragraph-2"
                    componentClasses={cx(styles.item, {
                        [styles.activeOperator]: checked === CheckedValue.right,
                        [styles.largeWidth]: largeWidth
                    })}
                >
                    {right}
                </Text>
            </div>
        );
    },
    (prev, next) => prev.checked === next.checked
);
